import type { CartUI } from '@libs/common-node';
import type { DeliveryType, Nullable } from '../../../core/src';

export const hasFulfillmentMethodInCart = (
    cart: Nullable<CartUI>,
    deliveryType: DeliveryType
) =>
    cart?.fulfillmentGroups?.some(
        group =>
            group.fulfillmentMethod.toLowerCase() === deliveryType.toLowerCase()
    );
